import React from "react";
import home1 from "../../assets/Home/home-1.png";
import { Link } from "react-router-dom";
import "./Home.css";
import { useState } from "react";
import { Button } from "react-bootstrap";
import glance from "../../assets/Home/glance.png";
import glance1 from "../../assets/Home/glance1.png";
import glance2 from "../../assets/Home/glance2.png";
import glance3 from "../../assets/Home/glance3.png";
import glance4 from "../../assets/Home/glance4.png";
import service1 from "../../assets/Home/service1.png";
import service2 from "../../assets/Home/service2.png";
import service3 from "../../assets/Home/service3.png";
import service4 from "../../assets/Home/service4.png";
import service5 from "../../assets/Home/service5.png";
import project1 from "../../assets/Home/project1.png";
import project2 from "../../assets/Home/project2.png";
import project3 from "../../assets/Home/project3.png";
import tick from "../../assets/Home/tick.png";
import { Row, Col } from "react-bootstrap";
import safetyC from "../../assets/Home/saftey-commitement.png";
import CountUp from 'react-countup';

import c1 from "../../assets/Home/c1.png";
import c2 from "../../assets/Home/c2.png";
import c3 from "../../assets/Home/c3.png";
import c4 from "../../assets/Home/c4.png";
import c5 from "../../assets/Home/c5.png";

import tustedlogo1 from '../../assets/Projects/tustedlogo1.png'
import tustedlogo2 from '../../assets/Projects/tustedlogo2.png'
import tustedlogo3 from '../../assets/Projects/tustedlogo3.png'
import tustedlogo4 from '../../assets/Projects/tustedlogo4.png'
import tustedlogo5 from '../../assets/Projects/tustedlogo5.png'
import tustedlogo6 from '../../assets/Projects/tustedlogo6.png'
import tustedlogo7 from '../../assets/Projects/tustedlogo7.png'
import tustedlogo8 from '../../assets/Projects/tustedlogo8.png'
import tustedlogo9 from '../../assets/Projects/tustedlogo9.png'
import tustedlogo10 from '../../assets/Projects/tustedlogo10.png'
import tustedlogo11 from '../../assets/Projects/tustedlogo11.png'
import tustedlogo12 from '../../assets/Projects/tustedlogo12.png'
import tustedlogo13 from '../../assets/Projects/tustedlogo13.png'
import tustedlogo14 from '../../assets/Projects/tustedlogo14.png'

import homepageimage from '../../assets/Home/Homepageimage.png'
import BlueRightArrow from '../../assets/Contactus/blue-right-arrow.png'

// import Carousel from "react-multi-carousel/lib";
//     import "react-multi-carousel/lib/styles.css";


const tustedLogos = [
  tustedlogo1,tustedlogo2,
  tustedlogo3,tustedlogo4,
  tustedlogo5,tustedlogo6,
  tustedlogo7,tustedlogo8,
  tustedlogo9,tustedlogo10,
  tustedlogo11,tustedlogo12,
  tustedlogo13,tustedlogo14,

]

const Home = () => {
   const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // or 'auto'
  };
  
  const images = [c1, c2, c3, c4, c5];
  return (
    <>
      <div className="home-image-container">
        <div className="overlay-text-container">
          <h1 className="home-main-heading">Delivering Engineering & <span className="home-page-span">Construction</span></h1>
          <p>Excellence Since 2001</p>
          <p className="home-main-description">Trusted partner in Oil & Gas, Infrastructure, Power, Petrochemical & Water Industries.</p>
            <div
            style={{
              marginTop:"12px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "15px",
            }}
          > 
            <Link to="/contact" onClick={scrollToTop} className="buttonStyleGet">
            Get a Quote
          </Link>
            <Link to="/projects" onClick={scrollToTop} className="buttonStyleProjects">
            View Projects
          </Link>
          </div>
        </div>
      </div>
      
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "20px",
          marginBottom: "5%",
        }}
        className="tauc-at-a-glance-main-container"
      >
        <div className="tauc-at-a-glance-content-container">
          <h3 style={{ fontWeight: "bold" }} className="tauc-at-a-glance-heading">
            Building Tomorrow's
            <br />
            Infrastructure Today
          </h3>

          <p style={{ marginTop: "9%" }} className="tauc-at-a-glance-description">
            For over two decades, TAUC has been at the forefront of engineering
            and construction excellence in Saudi Arabia. We combine innovative
            solutions with proven expertise to deliver projects that shape the
            future.
          </p>
          <p style={{ marginTop: "5%" }} className="tauc-at-a-glance-description">
            Our vision is to be the leading engineering and construction company
            in the region, recognized for our commitment to quality, safety, and
            sustainable development
          </p>
        </div>
        <div style={{ marginLeft: "5%", marginTop: "3%" }} className="tauc-at-a-glance-boxs-main-container">
          <img src={glance}  className="tauc-image"/>
          <Row className="icon-mobile-card-container">
            <Col className="icon-mobile-card-container">
              <div className="icon-card mobile-icon-card mt-5">
                <img src={glance1} alt="Icon" className="icon-image" />
                <h3>
                  <CountUp start={0} end={2001} duration={10.5} className="count-text"/>
                </h3>
                <p>Founded</p>
              </div>
            </Col>
            <Col className="icon-mobile-card-container">
              <div className="icon-card mobile-icon-card mt-5">
                <img src={glance3} alt="Icon" className="icon-image" />
                <h3>
                <CountUp start={0} end={60} duration={10.5} className="count-text" />{' '}
                <span className="plus-sign">+</span>
              </h3>
                <p>Skilled Employees</p>
              </div>
            </Col>
          </Row>
          <Row className="icon-mobile-card-container">
            <Col className="icon-mobile-card-container">
              <div className="icon-card mobile-icon-card mt-5">
                <img src={glance4} alt="Icon" className="icon-image" />
                <h3>
                <CountUp start={0} end={30} duration={10.5} className="count-text" />{' '}
                <span className="plus-sign">+</span>
              </h3>

                <p>Major Projects</p>
              </div>
            </Col>
            <Col className="icon-mobile-card-container">
              <div className="icon-card mobile-icon-card mt-5">
                <img src={glance2} alt="Icon" className="icon-image" />
               <h3>
                <CountUp start={0} end={100} duration={10.5} className="count-text" />{' '}
                <span className="plus-sign">+</span>
              </h3>
                <p>Equipment Fleet</p>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      
      <div className="gradient-div" style={{ marginBottom: "14%" }}>
        <h2 style={{ color: "#fff", marginTop: "15%" }} className="our-core-services-heading">Our Core Services</h2>
        <p style={{ color: "#fff" }} className="our-core-services-description">
          Comprehensive engineering and construction solutions across multiple
          industries
        </p>
        <Row className="our-core-services-main-card-container">
          <Col>
            <div className="services-card mt-3">
              <img src={service1} alt="Icon" className="icon-image" />
              <h3 className="our-core-services-sub-heading">Engineering & Design</h3>
              <p className="our-core-services-sub-description">
                Innovative design solutions and comprehensive engineering
                services
              </p>
            </div>
          </Col>
          <Col>
            <div className="services-card mt-3">
              <img src={service2} alt="Icon" className="icon-image" />
              <h3>EPC & Project Management</h3>
              <p>
                End-to-end project delivery with expert management oversight
              </p>
            </div>
          </Col>
          <Col>
            <div className="services-card mt-3">
              <img src={service3} alt="Icon" className="icon-image" />
              <h3>Civil/Mechanical Works</h3>
              <p>Structural and mechanical construction expertise</p>
            </div>
          </Col>
          <Col>
            <div className="services-card mt-3">
              <img src={service4} alt="Icon" className="icon-image" />
              <h3>Electrical & Instrumentation</h3>
              <p>Advanced electrical systems and precision instrumentation</p>
            </div>
          </Col>
          <Col>
            <div className="services-card mt-3">
              <img src={service5} alt="Icon" className="icon-image" />
              <h3>Telecom & Security</h3>
              <p>Communication networks and security system integration</p>
            </div>
          </Col>
        </Row>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* <button className="buttonStyleGet mb-5">Explore All Services</button> */}
        <Link to="/services" onClick={scrollToTop} className="buttonStyleGet mb-5">
        Explore All Services
      </Link>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
        className="mt-2 featured-projects-main-container"
         
      >
        <h2 className="featured-projects-main-heading">Featured Projects</h2>
        <p className="featured-projects-main-description">Showcasing our commitment to excellence across diverse industries</p>
        <Row style={{ marginTop: "3%", gap: "40px" }} className="projects-mobile-main-container">
          <Col>
            <div className="custom-card">
              <div className="card-image">
                <img src={project1} alt="Card Image" />
              </div>
              <div className="card-content">
                <div className="card-row">
                  <h3>FADHILI GAS PLANT PIPELINE PROJECT</h3>
                  <span className="status">Ongoing</span>
                </div>
                <div className="card-p">
                  <p style={{ marginTop: "15px" }}>Client: A HAK COMPANY</p>
                  <p style={{ marginTop: "-10px", marginBottom: "20px" }}>
                    Contractor: ARAMCO  
                  </p>
                </div>
              </div>
            </div>
          </Col>
          <Col>
            <div className="custom-card">
              <div className="card-image">
                <img src={project2} alt="Card Image" />
              </div>
              <div className="card-content">
                <div className="card-row">
                  <h3>Haram Mecca Project</h3>
                  <span className="status">Ongoing</span>
                </div>
                <div className="card-p">
                  <p style={{ marginTop: "15px" }}>
                    Client: Saudi Bin Laden Group
                  </p>
                  <p style={{ marginTop: "-10px", marginBottom: "20px" }}>
                    Contractor: Seele Company
                  </p>
                </div>
              </div>
            </div>
          </Col>
          {/* <Col>
            <div className="custom-card">
              <div className="card-image">
                <img src={project3} alt="Card Image" />
              </div>
              <div className="card-content">
                <div className="card-row">
                  <h3>Gas Compression Replacement – Shedgum Plant</h3>
                  <span className="status">Ongoing</span>
                </div>
                <div className="card-p">
                  <p style={{ marginTop: "5px" }}>
                    Client: Saudi Aramco (via AHC)
                  </p>
                  <p style={{ marginTop: "-10px" }}>
                    Contractor: A HAK Company
                  </p>
                </div>
              </div>
            </div>
          </Col> */}
        </Row>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "3%",
          }}
        >
          {/* <button className="buttonStylePortfolio">View Full Portfolio</button> */}
          <Link to="/projects" onClick={scrollToTop} className="buttonStylePortfolio">
            View Full Portfolio
          </Link>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center", // horizontal center
            alignItems: "center", // vertical center
            // full viewport height
            padding: "20px",
            boxSizing: "border-box",
          }}
        >
          <Row style={{ maxWidth: "1200px", width: "100%" }}>
            <Col md={6} style={{ padding: "30px" }}>
              <div>
                <h3>Quality & Safety Commitment</h3>
                <p>
                  We maintain the highest standards of quality, health, safety,
                  and environmental protection across all our operations. Our
                  certifications include ISO 9001, 14001, and 45001.
                </p>
              </div>

              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "15px",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "15px" }}
                >
                  <img
                    src={tick}
                    style={{
                      width: "30px",
                      height: "30px",
                      marginTop: "-10px",
                    }}
                  />
                  <p>ISO 9001:2015 Quality Management</p>
                </div>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "15px" }}
                >
                  <img
                    src={tick}
                    style={{
                      width: "30px",
                      height: "30px",
                      marginTop: "-10px",
                    }}
                  />
                  <p>ISO 14001:2015 Environmental Management</p>
                </div>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "15px" }}
                >
                  <img
                    src={tick}
                    style={{
                      width: "30px",
                      height: "30px",
                      marginTop: "-10px",
                    }}
                  />
                  <p>ISO 45001:2018 Occupational Health & Safety</p>
                </div>
              </div>
            </Col>

            <Col
              md={6}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img src={safetyC} style={{ width: "80%", height: "auto" }} />
            </Col>
          </Row>
        </div>

        <div className="gradient-div-trusted" style={{color:"#000"}}>
            <h3 style={{color:'#fff',marginTop:'3%'}}>Trusted by Leading Companies</h3>
            <p style={{color:'#fff',textAlign:'center'}}>Serving Saudi Arabia's most prestigious organizations for over 20 years</p>


          <div className="auto-logo-wrapper">
            <div className="logos-scroll">
              <div className="logos-group">
                {tustedLogos.map((logo, idx) => (
                  <img key={`logo-${idx}`} src={logo} alt={`logo-${idx}`} className="logo-img" />
                ))}
              </div>
            </div>
          </div>  

            {/* <div className="tusted-logos-container"> 
              <img src={tustedlogo1} alt="tusted-logo" />
              <img src={tustedlogo1} alt="tusted-logo" />
              <img src={tustedlogo1} alt="tusted-logo" />
              <img src={tustedlogo1} alt="tusted-logo" />
              <img src={tustedlogo1} alt="tusted-logo" />
              <img src={tustedlogo1} alt="tusted-logo" />
              <img src={tustedlogo1} alt="tusted-logo" />
              <img src={tustedlogo1} alt="tusted-logo" />
              <img src={tustedlogo1} alt="tusted-logo" />
              <img src={tustedlogo1} alt="tusted-logo" />
              <img src={tustedlogo1} alt="tusted-logo" /> */}
            {/* </div> */}
        </div>

        {/* <Carousel
          responsive={responsive}
          infinite={true} 
          autoPlay={true} 
          autoPlaySpeed={3000} 
          showDots={true} 
         
        >
          <div>Item 1</div>
          <div>Item 2</div>
          <div>Item 3</div>
          <div>Item 4</div>
        </Carousel> */}
       

          {/* <Carousel
            responsive={responsive}
            infinite={true}
            autoPlay={true}
            autoPlaySpeed={3000}
            showDots={true}
          >
            <div>Item 1</div>
            <div>Item 2</div>
            <div>Item 3</div>
            <div>Item 4</div>
          </Carousel> */}

        <div className="future-gradient-div">
          <h1 style={{ color: "#fff",textAlign:'center' }} className="future-main-heading">Let's Build the Future Together</h1>
          <p style={{ color: "#fff", textAlign: "center",width:'90%' }} className="future-main-description">
            Ready to start your next project? Partner with TAUC for engineering
            excellence <br /> and construction expertise you can trust.
          </p>
          {/* <button className="buttonStyleContact" style={{ color: "#1E3A8A" }}>
            Contact Us Today
          </button> */}
          <Link to="/contact" onClick={scrollToTop} className="buttonStyleContact" style={{ color: "#1E3A8A" , textDecoration:"none"}}>
          Contact Us Today <img src={BlueRightArrow} alt='blue-right-arrow' className="blue-right-arrow" />        </Link>
        </div>
      </div>
    </>
  );
};
export default Home;
